<template>
  <v-card class="mx-auto overflow-visible " width="1000px" style="margin-top: 0px; margin-bottom: 0px;" outlined>
    <v-list-item three-line>
      <v-list-item-content class="overflow-visible">
        <v-row class="align-center">
          <v-col cols="10">
            <v-list-item-title class="headline mb-2">Tìm kiếm nâng cao</v-list-item-title>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon aria-label="Close" @click="closeMenu">mdi-close</v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="checkAuthorization('admin-search_read') ? 7 : 12">
            <v-row>
              <v-col cols="12" md="4">
                <common-range-picker
                        :clearable="true"
                        :aLight="'right'"
                        :class="this.currentPicker === 4 ? 'show-date' : 'hide-date'"
                        label="Ngày đăng ký gần nhất"
                        v-model="filterForm.importUpdatedAt"
                        @show-date-picker="showDate(4)"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="4">
                <common-range-picker
                        :clearable="true"
                        :aLight="'center'"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        label="Ngày được cấp contact"
                        v-model="filterForm.assignedAt"
                        @show-date-picker="showDate(1)"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="4">
                <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        :class="this.currentPicker === 5 ? 'show-date' : 'hide-date'"
                        label="Ngày tạo đơn"
                        v-model="filterForm.orderCreatedAt"
                        @show-date-picker="showDate(5)"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="4"
                 v-if="!(filterForm.typeId == moduleTypes.TU_HOC &&
                (filterForm.schoolLevelId == moduleSchoolLevel.TH ||
                 filterForm.schoolLevelId == moduleSchoolLevel.THCS) &&
                 !USER_NOT_SHOW_CONTACT_SOURCE.includes(userId))"
              >
                <v-autocomplete
                  v-model="filterForm.contactSourceIds"
                  :items="contactSources"
                  item-text="name"
                  item-value="id"
                  label="Nguồn khách hàng"
                  placeholder="Tìm kiếm theo nguồn khách hàng"
                  multiple
                  clearable
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="filterForm.statusIds"
                  :items="selectContactStatusList"
                  item-text="name"
                  item-value="id"
                  label="Mối quan hệ"
                  placeholder="Tìm kiếm theo mối quan hệ"
                  multiple
                  clearable
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="4">
                <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        :class="this.currentPicker === 6 ? 'show-date' : 'hide-date'"
                        label="Ngày hết hạn"
                        v-model="filterForm.expiredDate"
                        @show-date-picker="showDate(6)"
                        :hasEternal="true"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="filterForm.productGroupIds"
                  :items="productGroups"
                  item-text="name"
                  item-value="id"
                  label="Nhóm sản phẩm"
                  placeholder="Tìm kiếm theo nhóm sản phẩm"
                  multiple
                  clearable
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <common-select-year
                  v-model="filterForm.years"
                  label="Năm sinh"
                  placeholder="Tìm kiếm theo năm sinh"
                  multiple
                  clearable
                  :hideDetails="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <common-range-picker
                        @show-date-picker="showDate(2)" :clearable="true"
                        :aLight="'center'"
                        :class="this.currentPicker === 2 ? 'show-date' : 'hide-date'"
                        label="Ngày liên hệ thành công gần nhất"
                        v-model="filterForm.lastSuccessCallAt"
                        :hideDetails="true">
                  </common-range-picker>
              </v-col>
              <v-col cols="12" md="6">
                <common-range-picker
                        @show-date-picker="showDate(10)" :clearable="true"
                        :aLight="'center'"
                        :class="this.currentPicker === 10 ? 'show-date' : 'hide-date'"
                        label="Loại trừ ngày liên hệ gần nhất"
                        v-model="filterForm.notCallAt"
                        :hideDetails="true">
                  </common-range-picker>
              </v-col>
<!--              <v-col cols="12" md="4">-->
<!--                <common-select-user-->
<!--                  class="btn-style-all"-->
<!--                  v-model="filterForm.userIds"-->
<!--                  :items="usersTemp"-->
<!--                  color="primary"-->
<!--                  item-text="fullName"-->
<!--                  item-value="id"-->
<!--                  multiple-->
<!--                  placeholder="Tìm kiếm theo người phụ trách"-->
<!--                  label="Người phụ trách"-->
<!--                  hideDetails-->
<!--                  showInactive-->
<!--                />-->
<!--              </v-col>-->

              <!-- Danh sách người phụ trách theo dạng cây-->
              <v-col cols="12" md="4">
                <v-menu
                    bottom
                    offset-y
                    content-class="menu-wrapper-tree-user"
                    :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind="attrs"
                        v-on="on"
                        v-if="!filterForm.userIds.length"
                        @click="clickSelectUser()">
                      <v-select
                          v-model="filterForm.userIds"
                          label="Người phụ trách"
                          readonly
                          hide-details
                          placeholder="Tìm kiếm theo người phụ trách"
                      >
                      </v-select>
                    </div>
                    <div
                        style="position: relative"
                        v-else
                        v-bind="attrs"
                        v-on="on">
                      <div style="font-size: 10px">Người phụ trách</div>
                      <div class="mt-1 tree-user-selected">
                        <span
                            v-for="node in filterForm.userIds"
                            :key="node.id"
                        >
                          {{ node.name }}
                        </span>
                      </div>
                      <v-icon
                          class="icon-clear-all"
                          @click="removeNodeSelected()">mdi-close-circle
                      </v-icon>
                    </div>
                  </template>

                  <template>
                    <v-list>
                      <v-text-field
                          class="px-6 py-2"
                          label="Tìm kiếm..."
                          v-model="search"
                          @input="handleSearch"
                      >
                      </v-text-field>

                      <v-treeview
                          v-if="ministries[0].children.length"
                          class="pr-4 pl-3 tree-view-wrapper"
                          v-model="filterForm.userIds"
                          selectable
                          :items="ministries"
                          return-object
                          ref="tree"
                          open-on-click
                          :search="search"
                          :open.sync="open"
                          open-all
                      ></v-treeview>
                    </v-list>
                  </template>

                </v-menu>
              </v-col>

              <v-col cols="12" md="4" class="py-0">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      :items="typeSearch"
                      item-text="label"
                      item-value="value"
                      label="So sánh"
                      v-model="filterForm.typeNumberOfCall"
                      eager
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      type="number"
                      min="0"
                      step="1"
                      label="Số lần gọi"
                      placeholder="Tìm kiếm theo số lần gọi"
                      v-model="filterForm.numberOfCall"
                      hide-details>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Tên con"
                  placeholder="Tìm kiếm theo tên con"
                  v-model="filterForm.childName"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="4">
                <common-range-picker
                    :clearable="true"
                    :aLight="'right'"
                    placeholder="Tìm kiếm theo Ngày giao hàng thành công"
                    :class="this.currentPicker === 4 ? 'show-date' : 'hide-date'"
                    label="Ngày giao hàng thành công"
                    v-model="filterForm.orderSuccessDate"
                    @show-date-picker="showDate(4)"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                    v-model="filterForm.orderStatus"
                    :items="orderStatusList"
                    item-text="name"
                    item-value="id"
                    label="Trạng thái đơn"
                    placeholder="Tìm kiếm theo trạng thái đơn"
                    clearable
                    hide-details
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-row>
                  <v-col cols="12" md="6" class="py-0 pr-0">
                    <common-range-picker
                        :clearable="true"
                        :minDate="minDateContacted"
                        :showRanges="false"
                        :aLight="'left'"
                        :class="this.currentPicker === 9 ? 'show-date' : 'hide-date'"
                        label="Ngày tìm kiếm"
                        v-model="filterForm.contactedAt"
                        @show-date-picker="showDate(9)"
                    ></common-range-picker>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0">
                    <v-autocomplete
                        v-model="filterForm.isContacted"
                        :items="contactedStatusList"
                        item-text="name"
                        item-value="id"
                        label="Trạng thái liên hệ"
                        placeholder="Tìm kiếm theo trạng thái liên hệ"
                        clearable
                        hide-details
                    />
                  </v-col>
                  <v-col cols="12" v-if="showContactedErrors">
                    <span style="color: red">Chọn thời gian tìm kiếm.</span>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="12" class="py-0">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-menu
                      ref="menu"
                      v-model="isMonthPicker"
                      :close-on-content-click="false"
                      :return-value.sync="filterForm.monthPicker"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterForm.monthPicker"
                          label="Chọn tháng"
                          append-icon="mdi-calendar"
                          clearable
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterForm.monthPicker"
                        type="month"
                        locale="vi"
                        no-title
                        scrollable
                        @input="$refs.menu.save(filterForm.monthPicker)"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-row>
                      <v-col cols="6" class="py-0">
                        <v-select
                          v-model="filterForm.compare"
                          :items="typeSearch"
                          item-text="label"
                          item-value="value"
                          label="So sánh"
                          hide-details
                        />
                      </v-col>
                      <v-col cols="6" class="py-0">
                        <v-text-field
                          type="number"
                          min="0"
                          clearable
                          label="Điểm lũy kế"
                          placeholder="Nhập số"
                          v-model="filterForm.inputPointCumulated"
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="4" class="py-0">
                    <v-text-field
                        clearable
                        label="Độ tuổi"
                        placeholder="Nhập độ tuổi"
                        v-model="filterForm.birthdayDescription"
                        hide-details>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" class="py-0">
                    <v-text-field
                        clearable
                        label="Mã kích hoạt"
                        placeholder="Nhập mã kích hoạt"
                        v-model="filterForm.activeCodes"
                        max-length="68"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" class="py-0">
                    <v-autocomplete
                        v-model="filterForm.hasActiveCode"
                        :items="activeCodeStatusList"
                        item-text="name"
                        item-value="id"
                        label="Trạng thái mã KH"
                        placeholder="Tìm kiếm theo trạng thái mã KH"
                        clearable
                        hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="py-0">
                    <v-select
                      v-model="filterForm.isRegistedCapacity"
                      :items="FILTER_DGNL"
                      label="Tìm contact thi DGNL"
                      hide-details
                      clearable
                    />
                  </v-col>
                </v-row>

                <v-col cols="12" v-if="showCumulatedErrors" class="py-0">
                  <span style="color: red">Vui lòng chọn đầy đủ thời gian và so sánh điểm lũy kế!</span>
                </v-col>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                    :clearable="true"
                    label="Tag"
                    :items="tags"
                    item-text="tagName"
                    item-value="tagCode"
                    v-model="filterForm.tags"
                    multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                  <v-autocomplete
                          :clearable="true"
                          label="Tệp khách hàng"
                          :items="listSegment"
                          item-value="id"
                          item-text="segmentCode"
                          v-model="filterForm.segmentId"
                          multiple
                  ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                    clearable
                    label="Tìm kiếm theo tài khoản social"
                    placeholder="Nhập ID tài khoản hoặc tên tài khoản"
                    v-model="filterForm.zuid"
                    max-length="68"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                    clearable
                    label="Mã content MKT"
                    placeholder="Vui lòng nhập chính xác mã"
                    v-model="filterForm.codeSource"
                    max-length="68"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                    clearable
                    label="Đăng kí khoá học"
                    placeholder="Nhập thông tin"
                    v-model="filterForm.productDescription"
                    max-length="68"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>


          <v-col cols="5" v-if="checkAuthorization('admin-search_read')">
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <v-row>
                  <v-col cols="12" md="6" class="pr-0">
                    <v-select
                      v-model="filterForm.typeOrderTotalPrice"
                      :items="typeSearch"
                      item-text="label"
                      item-value="value"
                      label="So sánh"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      type="number"
                      min="0"
                      step="500"
                      label="Tổng giá trị đơn"
                      placeholder="Nhập tổng giá trị đơn"
                      v-model="filterForm.orderTotalPrice"
                      hide-details>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-row>
                  <v-col cols="12" md="6" class="pr-0">
                    <v-select
                        v-model="filterForm.typeCumulativePoint"
                        :items="typeSearch"
                        item-text="label"
                        item-value="value"
                        label="So sánh"
                        hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                        type="number"
                        min="0"
                        step="1"
                        label="Số điểm chấm"
                        placeholder="Tìm kiếm theo số điểm chấm"
                        v-model="filterForm.cumulativePoint"
                        hide-details
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="filterForm.boughtProduct"
                  :items="productList"
                  item-text="name"
                  item-value="id"
                  label="Sản phẩm đã mua"
                  placeholder="Chọn sản phẩm"
                  clearable
                  multiple
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <common-range-picker
                    :clearable="true"
                    :aLight="'left'"
                    :class="this.currentPicker === 7 ? 'show-date' : 'hide-date'"
                    label="Lịch sử cấp contact"
                    v-model="filterForm.assignedAtHistory"
                    @show-date-picker="showDate(7)"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="filterForm.unBoughtProduct"
                  :items="productList"
                  item-text="name"
                  item-value="id"
                  label="Sản phẩm chưa mua"
                  placeholder="Chọn sản phẩm"
                  clearable
                  multiple
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <common-range-picker
                    :clearable="true"
                    :aLight="'left'"
                    :class="this.currentPicker === 8 ? 'show-date' : 'hide-date'"
                    label="Loại trừ ngày cấp contact"
                    v-model="filterForm.neAssignedAt"
                    @show-date-picker="showDate(8)"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="filterForm.customerResult"
                  :items="studyResults"
                  item-text="label"
                  item-value="code"
                  label="Kết quả học tập"
                  placeholder="Chọn kết quả"
                  clearable
                  hide-details
                  multiple
                />
              </v-col>
              <!-- <v-col cols="12" md="6">
                <v-autocomplete
                    v-model="filterForm.schoolLevelId"
                    :items="schoolLevelList"
                    item-text="name"
                    item-value="id"
                    label="Nhóm ngành"
                    placeholder="Tìm kiếm theo nhóm ngành"
                    clearable
                    hide-details
                />
              </v-col> -->
              <v-col cols="12" md="6">
                <v-autocomplete
                    v-model="filterForm.tinhId"
                    :items="provinceList"
                    item-text="ten"
                    item-value="id"
                    label="Tỉnh/Thành phố"
                    placeholder="Tìm kiếm theo tỉnh/thành"
                    clearable
                    hide-details
                    @change="getDistrictLists(filterForm.tinhId)"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                    bottom
                    offset-y
                    content-class="menu-wrapper-tree-user"
                    :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind="attrs"
                        v-on="on"
                        v-if="!filterForm.orderCreatedBy.length"
                        @click="clickSelectUser()">
                      <v-select
                          v-model="filterForm.orderCreatedBy"
                          label="Người tạo đơn"
                          readonly
                          hide-details
                          placeholder="Tìm kiếm theo Người tạo đơn"
                      >
                      </v-select>
                    </div>
                    <div
                        style="position: relative"
                        v-else
                        v-bind="attrs"
                        v-on="on">
                      <div style="font-size: 10px">Người tạo đơn</div>
                      <div class="mt-1 tree-user-selected">
                        <span
                            v-for="node in filterForm.orderCreatedBy"
                            :key="node.id"
                        >
                          {{ node.name }}
                        </span>
                      </div>
                      <v-icon
                          class="icon-clear-all"
                          @click="removeOrderSelected()">mdi-close-circle
                      </v-icon>
                    </div>
                  </template>

                  <template>
                    <v-list>
                      <v-text-field
                          class="px-6 py-2"
                          label="Tìm kiếm..."
                          v-model="search"
                          @input="handleSearch"
                      >
                      </v-text-field>

                      <v-treeview
                          v-if="ministries[0].children.length"
                          class="pr-4 pl-3 tree-view-wrapper"
                          v-model="filterForm.orderCreatedBy"
                          selectable
                          :items="ministries"
                          return-object
                          ref="tree"
                          open-on-click
                          :search="search"
                          :open.sync="open"
                          open-all
                      ></v-treeview>
                    </v-list>
                  </template>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                    v-model="filterForm.huyenId"
                    :items="districtList"
                    item-text="ten"
                    item-value="id"
                    label="Quận/Huyện"
                    placeholder="Tìm kiếm theo Quận/Huyện"
                    clearable
                    hide-details
                    @change="getSchoolLists(filterForm.huyenId)"
                />
              </v-col>
<!--              <v-col cols="12" md="6">-->
<!--                <v-autocomplete-->
<!--                    v-model="filterForm.trialStatus"-->
<!--                    :items="trialStatusList"-->
<!--                    item-text="name"-->
<!--                    item-value="code"-->
<!--                    label="Trạng thái học thử"-->
<!--                    placeholder="Tìm kiếm theo trạng thái học thử"-->
<!--                    multiple-->
<!--                    clearable-->
<!--                    hide-details-->
<!--                >-->
<!--                  <template #prepend-item>-->
<!--                    <common-select-all-->
<!--                        v-model="filterForm.trialStatus"-->
<!--                        :item="trialStatusList"-->
<!--                        :items="trialStatusList.map(e => e.code)"-->
<!--                    ></common-select-all>-->
<!--                  </template>-->
<!--                </v-autocomplete>-->
<!--              </v-col>-->
              <v-col v-if="!filterForm.moduleSchoolLevelId" cols="12" md="6">
                <v-autocomplete
                    v-model="filterForm.schoolLevelId"
                    :items="schoolLevelList"
                    item-text="name"
                    item-value="id"
                    label="Nhóm ngành"
                    placeholder="Tìm kiếm theo nhóm ngành"
                    clearable
                    hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                 <v-autocomplete
                         v-model="filterForm.schoolName"
                         :items="schoolListComputed"
                         item-text="name"
                         item-value="name"
                         label="Trường học"
                         :search-input.sync="searchSchool"
                         placeholder="Tìm kiếm theo Trường học"
                         clearable
                         hide-details
                 />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                    :aLight="'right'"
                    :items="socialConnect"
                    item-text="type"
                    item-value="id"
                    label="Kết nối tài khoản social"
                    placeholder="Tìm kiếm theo MXH"
                    clearable
                    hide-details
                    v-model="filterForm.socialValue"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <common-range-picker
                    :clearable="true"
                    :aLight="'left'"
                    label="Ngày làm test"
                    v-model="filterForm.appointmentTestTime"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="6">
                <common-range-picker
                    :clearable="true"
                    :aLight="'left'"
                    label="Ngày phỏng vấn"
                    v-model="filterForm.appointmentInterviewTime"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="6">
                <common-range-picker
                    :clearable="true"
                    :aLight="'left'"
                    label="Ngày có kết quả"
                    v-model="filterForm.testResultTime"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="6" v-if="moduleTypes.IELTS_Y === moduleTypeCurrentUser">
                <common-range-picker
                    :clearable="true"
                    :aLight="'left'"
                    label="Ngày học thử"
                    v-model="filterForm.trialDate"
                ></common-range-picker>
              </v-col>

              <v-col cols="12" md="8" v-if="moduleTypes.IELTS_Y === moduleTypeCurrentUser">
                <v-autocomplete
                  v-model="filterForm.statusTrial"
                  :items="statusTrial"
                  item-text="name"
                  item-value="id"
                  label="Trạng thái học thử"
                  multiple
                  clearable
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="12" v-if="moduleTypes.IELTS_Y === moduleTypeCurrentUser">
                <v-row>
                  <div class="my-auto pt-5 pl-3">Lần học thử</div>
                  <v-col cols="12" md="3" class="pr-0 custom-font-input">
                    <v-select
                      v-model="filterForm.typeNumberOfLearnTrial"
                      :items="typeNumberOfLearnTrial"
                      item-text="label"
                      item-value="value"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="2" class="custom-font-input-number">
                    <v-text-field
                      type="number"
                      min="1"
                      max="99"
                      v-model="filterForm.numberOfLearnTrial"
                      @keyup.native="changenumberOfLearnTrial($event)"
                      hide-details>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                    :clearable="true"
                    label="Lịch test theo môn"
                    :items="subjectTest"
                    item-text="name"
                    item-value="id"
                    v-model="filterForm.subjectTest"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                    :clearable="true"
                    label="Đối tượng liên hệ"
                    :items="contactsObject"
                    item-text="title"
                    item-value="value"
                    v-model="filterForm.position"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-else>
            <v-row>
              <v-col cols="12" md="4" class="py-0">
                <v-row>
                  <v-col cols="12" md="5">
                    <v-select
                        v-model="filterForm.typeCumulativePoint"
                        :items="typeSearch"
                        item-text="label"
                        item-value="value"
                        label="So sánh"
                        hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="7">
                    <v-text-field
                        type="number"
                        min="0"
                        step="1"
                        label="Số điểm chấm"
                        placeholder="Tìm kiếm theo số điểm chấm"
                        v-model="filterForm.cumulativePoint"
                        hide-details
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                    v-model="filterForm.tinhId"
                    :items="provinceList"
                    item-text="ten"
                    item-value="id"
                    label="Tỉnh/Thành phố"
                    placeholder="Tìm kiếm theo tỉnh/thành"
                    clearable
                    hide-details
                    @change="getDistrictLists(filterForm.tinhId)"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                    v-model="filterForm.huyenId"
                    :items="districtList"
                    item-text="ten"
                    item-value="id"
                    label="Quận/Huyện"
                    placeholder="Tìm kiếm theo Quận/Huyện"
                    clearable
                    hide-details
                    @change="getSchoolLists(filterForm.huyenId)"
                />
              </v-col>
              <v-col cols="12" md="4">
                  <v-autocomplete
                          v-model="filterForm.schoolName"
                          :items="schoolListComputed"
                          item-text="name"
                          item-value="name"
                          label="Trường học"
                          clearable
                          hide-details
                          :search-input.sync="searchSchool"
                          placeholder="Tìm kiếm theo Trường học"
                  />
<!--                <v-autocomplete-->
<!--                    v-model="filterForm.schoolName"-->
<!--                    :items="schoolList"-->
<!--                    item-text="name"-->
<!--                    item-value="name"-->
<!--                    label="Trường học"-->
<!--                    placeholder="Tìm kiếm theo Trường học"-->
<!--                    clearable-->
<!--                    hide-details-->
<!--                />-->
              </v-col>
<!--              <v-col cols="12" md="4">-->
<!--                <v-autocomplete-->
<!--                    v-model="filterForm.trialStatus"-->
<!--                    :items="trialStatusList"-->
<!--                    item-text="name"-->
<!--                    item-value="code"-->
<!--                    label="Trạng thái học thử"-->
<!--                    placeholder="Tìm kiếm theo trạng thái học thử"-->
<!--                    multiple-->
<!--                    clearable-->
<!--                    hide-details-->
<!--                >-->
<!--                  <template #prepend-item>-->
<!--                    <common-select-all-->
<!--                        v-model="filterForm.trialStatus"-->
<!--                        :item="trialStatusList"-->
<!--                        :items="trialStatusList.map(e => e.code)"-->
<!--                    ></common-select-all>-->
<!--                  </template>-->
<!--                </v-autocomplete>-->
<!--              </v-col>-->
              <v-col v-if="!filterForm.moduleSchoolLevelId" cols="12" md="4">
                <v-autocomplete
                    v-model="filterForm.schoolLevelId"
                    :items="schoolLevelList"
                    item-text="name"
                    item-value="id"
                    label="Nhóm ngành"
                    placeholder="Tìm kiếm theo nhóm ngành"
                    clearable
                    hide-details
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                    :aLight="'right'"
                    :items="socialConnect"
                    item-text="type"
                    item-value="id"
                    label="Kết nối tài khoản social"
                    placeholder="Tìm kiếm theo MXH"
                    clearable
                    hide-details
                    v-model="filterForm.socialValue"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" v-if="moduleTypes.IELTS_Y === moduleTypeCurrentUser">
                <common-range-picker
                    :clearable="true"
                    :aLight="'left'"
                    label="Ngày học thử"
                    v-model="filterForm.trialDate"
                ></common-range-picker>
              </v-col>
              <v-col cols="12" md="6" v-if="moduleTypes.IELTS_Y === moduleTypeCurrentUser">
                <v-autocomplete
                  v-model="filterForm.statusTrial"
                  :items="statusTrial"
                  item-text="name"
                  item-value="id"
                  label="Trạng thái học thử"
                  multiple
                  clearable
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6" v-if="moduleTypes.IELTS_Y === moduleTypeCurrentUser">
                <v-row>
                  <div class="my-auto pt-5">Lần học thử</div>
                  <v-col cols="12" md="2" class="pr-0 custom-font-input">
                    <v-select
                      v-model="filterForm.typeNumberOfLearnTrial"
                      :items="typeNumberOfLearnTrial"
                      item-text="label"
                      item-value="value"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="2" class="custom-font-input-number">
                    <v-text-field
                      class="hihi"
                      type="number"
                      min="1"
                      max="99"
                      v-model="filterForm.numberOfLearnTrial"
                      @keyup.native="changenumberOfLearnTrial($event)"
                      hide-details>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-menu
                    bottom
                    offset-y
                    content-class="menu-wrapper-tree-user"
                    :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind="attrs"
                        v-on="on"
                        v-if="!filterForm.orderCreatedBy.length"
                        @click="clickSelectUser()">
                      <v-select
                          v-model="filterForm.orderCreatedBy"
                          label="Người tạo đơn"
                          readonly
                          hide-details
                          placeholder="Tìm kiếm theo Người tạo đơn"
                      >
                      </v-select>
                    </div>
                    <div
                        style="position: relative"
                        v-else
                        v-bind="attrs"
                        v-on="on">
                      <div style="font-size: 10px">Người tạo đơn</div>
                      <div class="mt-1 tree-user-selected">
                        <span
                            v-for="node in filterForm.orderCreatedBy"
                            :key="node.id"
                        >
                          {{ node.name }}
                        </span>
                      </div>
                      <v-icon
                          class="icon-clear-all"
                          @click="removeOrderSelected()">mdi-close-circle
                      </v-icon>
                    </div>
                  </template>

                  <template>
                    <v-list>
                      <v-text-field
                          class="px-6 py-2"
                          label="Tìm kiếm..."
                          v-model="search"
                          @input="handleSearch"
                      >
                      </v-text-field>

                      <v-treeview
                          v-if="ministries[0].children.length"
                          class="pr-4 pl-3 tree-view-wrapper"
                          v-model="filterForm.orderCreatedBy"
                          selectable
                          :items="ministries"
                          return-object
                          ref="tree"
                          open-on-click
                          :search="search"
                          :open.sync="open"
                          open-all
                      ></v-treeview>
                    </v-list>
                  </template>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div class="text-center mb-4">
          <v-btn class="primary mx-2" @click="searchContact">
            <v-icon>mdi-magnify</v-icon>Tìm kiếm nâng cao
          </v-btn>
          <v-btn v-if="checkAuthorization('contact_download')" class="primary mx-2" @click="exportExcel">
            <v-icon>mdi-download</v-icon>Download
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
import moment from 'moment'
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import {moduleTypes, moduleSchoolLevel, USER_NOT_SHOW_CONTACT_SOURCE} from '@/helpers/constants';
import { downloadFile } from '../../../helpers/utils';
import { subjectTest, CONTACTS_OBJECT, FILTER_DGNL } from '../../../helpers/constants';
const ContactRepository = RepositoryFactory.get('contact');
const TypeRepository = RepositoryFactory.get('type');
const AddressRepository = RepositoryFactory.get('address');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')

import TokenService from '../../../helpers/token';
export default {
  name: 'ContactStatusFilterForm',
  props: {
    users: {
      type: Array,
      default: () => []
    },
    productGroups: {
      type: Array,
      default: () => []
    },
    contactStatusList: {
      type: Array,
      default: () => []
    },
    contactSources: {
      type: Array,
      default: () => []
    },
    filterForm: {
      default: () => ({})
    },
    productList: {
      default: () => []
    },
    schoolLevelList: {
      default: () => []
    },
    inactiveUsers: {
      default: () => []
    },
    provinceList: {
      default: () => []
    },
    usersContactAdvise: {
      default: () => []
    },
    // ministries: {
    //   default: () => []
    // }
  },
  data () {
    return {
      searchSchool: '',
      moduleTypes,
      currentPicker: null,
      showPopupDate: false,
      usersTemp: [],
      userPostion: TokenService.getPosition(),
      showContactedErrors: false,
      minDateContacted: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      listSegment: [],
      typeSearch: [
        {
          label: 'Bằng',
          value: 'eq'
        }, {
          label: 'Lớn hơn',
          value: 'gt'
        }, {
          label: 'Nhỏ hơn',
          value: 'lt'
        }
      ],
      studyResults: [
        {
          label: 'Chăm chỉ',
          code: 'CHAMCHI'
        },
        {
          label: 'Bình thường',
          code: 'BINHTHUONG'
        },
        // {
        //   label: 'Lười',
        //   code: 'LUOIHOC'
        // },
        {
          label: 'Không học',
          code: 'KHONGHOC'
        },
        {
          label: 'Phức tạp',
          code: 'PHUCTAP'
        },
      ],
      orderStatusList: [
        {
          id: 'ok',
          name: 'Thành công'
        },
        {
          id: 'nok',
          name: 'Không thành công'
        }
      ],
      contactedStatusList: [
        {
          id: 1,
          name: 'Đã liên hệ'
        },
        {
          id: 2,
          name: 'Chưa liên hệ'
        },
      ],
      trialStatusList: [
        {
          name: 'CH',
          code: 'CH'
        },
        {
          name: 'TN',
          code: 'TN'
        },
        {
          name: 'V',
          code: 'V'
        }
      ],
      socialConnect:[
        {id:1,type:'Đã kết nối zalo'},
        {id:0,type:'Chưa kết nối zalo'}
      ],
      socialValue:null,
      ministries: [
        {
          id: 'root_100000000',
          name: 'Tất cả',
          children: []
        },
        {
          id: -1,
          userId: -1,
          name: 'Không người phụ trách'
        }
      ],
      openTree: false,
      search: '',
      open: [1],
      allOpened: false,
      lastOpen: [],
      ministriesClone: [],
      subjectTest,
      contactsObject: CONTACTS_OBJECT,
      showCumulatedErrors: false,
      isMonthPicker: false,
      districtList: [],
      schoolList: [],
      activeCodeStatusList: [
        {
          id: 1,
          name: 'Có mã'
        },
        {
          id: 2,
          name: 'Không có mã'
        }
      ],
      FILTER_DGNL,
      tags: [],
      statusTrial: [
        { id: 1, name: 'Chờ xác nhận' },
        { id: 2, name:'Từ chối' },
        { id: 3, name:'Xác nhận' },
        { id: 4, name:'Hủy lịch' },
        { id: 5, name:'Cần đổi lịch' },
        { id: 6, name:'Hoàn thành' },
      ],
      typeNumberOfLearnTrial:[
        {
          label: '=',
          value: 'eq'
        }, {
          label: '>',
          value: 'gt'
        }, {
          label: '<',
          value: 'lt'
        }, {
          label: '<=',
          value: 'lte'
        }, {
          label: '>=',
          value: 'gte'
        }
      ],
      moduleSchoolLevel,
      USER_NOT_SHOW_CONTACT_SOURCE,
      userId: +TokenService.getId(),
    }
  },
  created() {
    this.getListUserOfContact();
    this.getListTags();
    this.getListSegmentCode()
    // this.getListMinistryTree();
    // this.ministriesClone = _.cloneDeep(this.ministries)
    Bus.$on('change-drawer-side-bar', (filter) => {
      this.ministries[0].children = []
    })
  },
  computed: {
    selectContactStatusList() {
      const contactStatusList = [];
      const checkType = {};
      if (this.isStaff()) {
        _.remove(this.contactStatusList, function (e) {
          return e.type === 'T0';
        });
      }
      this.contactStatusList.forEach(contactStatus => {
        const typeContactStatus = contactStatus.type;
        if (!checkType[typeContactStatus]) {
          checkType[typeContactStatus] = true;
          if (contactStatusList.length > 0) {
            contactStatusList.push({ divider: true });
          }
          contactStatusList.push({ header: typeContactStatus });
        }
        contactStatusList.push(contactStatus);
      });
      return contactStatusList;
    },
    moduleTypeCurrentUser() {
      return this.$store.state.module.typeId
    },
    schoolListComputed() {
        if (this.searchSchool !== '' && this.searchSchool !== null && this.searchSchool !== undefined ) {
            const search = this.searchSchool.toLowerCase()
            const dataSearch= this.schoolList.filter(item => {
                const text = item.name.toLowerCase()
                return text.indexOf(search) > -1
            })
            return dataSearch.length === 0 ? [{ name: this.searchSchool }] : dataSearch
        }else {
            return this.schoolList
        }
    }
  },
  methods: {
    showDate(index) {
      this.currentPicker = index;
    },
    closeMenu() {
      this.filterForm.closeMenu = false
    },
    searchContact() {
      if (this.filterForm.isContacted && (!_.isArray(this.filterForm.contactedAt) || !this.filterForm.contactedAt.length)) {
        this.showContactedErrors = true
      } else if ((this.filterForm.monthPicker || this.filterForm.inputPointCumulated ) && (!this.filterForm.monthPicker ||  !this.filterForm.compare || !this.filterForm.inputPointCumulated)) {
        this.showCumulatedErrors = true;
      }
      else {
        this.showContactedErrors = false;
        this.showCumulatedErrors = false;
        Bus.$emit('contact-list-filter', this.filterForm);
      }
    },
    checkEmptyFilterForm() {
      let isExist = false;
      // check keyword
      const isExistKeyword = !!this.filterForm.keyword;

      const isExistSocialConnect = !!this.filterForm.socialValue;

      // check appointmentAt
      const isExistAppointmentAt = _.isArray(this.filterForm.appointmentAt) ? !!this.filterForm.appointmentAt.length : false;

      // check assignedAt
      const isExistAssignedAt = _.isArray(this.filterForm.assignedAt) ? !!this.filterForm.assignedAt.length : false;

      // check lastSuccessCallAt
      const isExistCallAt = _.isArray(this.filterForm.lastSuccessCallAt) ? !!this.filterForm.lastSuccessCallAt.length : false;

      // check notCallAt
      const isExistNotCallAt = _.isArray(this.filterForm.notCallAt) ? !!this.filterForm.notCallAt.length : false;

      // check years
      const isExistYears = _.isArray(this.filterForm.years) ? !!this.filterForm.years.length : false;

      // check statusIds
      const isExistStatusIds = _.isArray(this.filterForm.statusIds) ? !!this.filterForm.statusIds.length : false;

      // check userIds
      const isExistUserIds = _.isArray(this.filterForm.userIds) ? !!this.filterForm.userIds.length : false;

      // check contactSourceIds
      const isExistContactSourceIds = _.isArray(this.filterForm.contactSourceIds) ? !!this.filterForm.contactSourceIds.length : false;

      // check productGroupIds
      const isExistProductGroupIds = _.isArray(this.filterForm.productGroupIds) ? !!this.filterForm.productGroupIds.length : false;

      // check childName
      const isExistChildName = !!this.filterForm.childName;

      // check importUpdatedAt
      const isExistImportUpdatedAt = _.isArray(this.filterForm.importUpdatedAt) ? !!this.filterForm.importUpdatedAt.length : false;

      // check trialDate
      const isExistTrialDate= _.isArray(this.filterForm.trialDate) ? !!this.filterForm.trialDate.length : false;

      // check orderCreatedAt
      const isExistOrderCreatedAt = _.isArray(this.filterForm.orderCreatedAt) ? !!this.filterForm.orderCreatedAt.length : false;

      // check cumulativePoint
      const isExistCumulativePoint = !!this.filterForm.cumulativePoint

      // check orderTotalPrice
      const isExistOrderTotalPrice = !!this.filterForm.orderTotalPrice;

      // check customerResult
      const isExistCustomerResult = _.isArray(this.filterForm.customerResult) ? !!this.filterForm.customerResult.length : false;

      // check assignedAtHistory
      const isExistAssignedAtHistory = _.isArray(this.filterForm.assignedAtHistory) ? !!this.filterForm.assignedAtHistory.length : false;

      // check neAssignedAt
      const isExistNeAssignedAt = _.isArray(this.filterForm.neAssignedAt) ? !!this.filterForm.neAssignedAt.length : false;

      // check importUpdatedAt
      const isExistSchoolLevelId = !!this.filterForm.schoolLevelId;

      // check boughtProduct
      const isExistBoughtProduct = _.isArray(this.filterForm.boughtProduct) ? !!this.filterForm.boughtProduct.length : false;

      // check unBoughtProduct
      const isExistUnBoughtProduct = _.isArray(this.filterForm.unBoughtProduct) ? !!this.filterForm.unBoughtProduct.length : false;

      // check orderSuccessDate
      const isExistOrderSuccessDate = _.isArray(this.filterForm.orderSuccessDate) ? !!this.filterForm.orderSuccessDate.length : false;

      // check numberOfCall
      const isExistNumberOfCall = !!this.filterForm.numberOfCall;

      // check expiredDate
      const isExistExpiredDate = _.isArray(this.filterForm.expiredDate) ? !!this.filterForm.expiredDate.length : false;

      // check orderStatus
      const isExistOrderStatus = !!this.filterForm.orderStatus;

      // check isContacted
      const isExistIsContacted = !!this.filterForm.isContacted

      // check contactedAt
      const isExistContactedAt = _.isArray(this.filterForm.contactedAt) ? !!this.filterForm.contactedAt.length : false;

      // check tinhId
      const isExistTinhId = !!this.filterForm.tinhId

      // check nguoi tao don
      const isExistOrderCreatedBy = !!this.filterForm.orderCreatedBy

      // check ma kich hoat
      const isExistActiveCodes = !!this.filterForm.activeCodes

      // check trang thai ma kich hoat
      const isExistHasActiveCodes = !!this.filterForm.hasActiveCode

      // check tim contact thi DGNL
      const isExistRegistedCapacity = !!this.filterForm.isRegistedCapacity

      // check statustrial
      const isExistStatusTrial= _.isArray(this.filterForm.statusTrial) ? !!this.filterForm.statusTrial.length : false;

      // check numberOfLearnTrial
      const isExistNumberOfLearnTrial = !!this.filterForm.numberOfLearnTrial;

      // check codeSource
      const isExistCodeSource = !!this.filterForm.codeSource;

      // check productDescription
      const isExistProductDescription = !!this.filterForm.productDescription;

      isExist = isExistKeyword || isExistAppointmentAt || isExistAssignedAt || isExistCallAt || isExistNotCallAt || isExistYears || isExistStatusIds || isExistUserIds || isExistContactSourceIds || isExistProductGroupIds || isExistChildName || isExistImportUpdatedAt || isExistTrialDate || isExistStatusTrial || isExistNumberOfLearnTrial
          || isExistOrderCreatedAt || isExistCumulativePoint || isExistOrderTotalPrice || isExistCustomerResult || isExistAssignedAtHistory || isExistNeAssignedAt || isExistSchoolLevelId || isExistBoughtProduct
          || isExistUnBoughtProduct || isExistOrderSuccessDate || isExistNumberOfCall || isExistExpiredDate || isExistOrderStatus || isExistRegistedCapacity
          || isExistIsContacted || isExistContactedAt || isExistTinhId || isExistSocialConnect || isExistOrderCreatedBy || isExistActiveCodes || isExistHasActiveCodes || isExistCodeSource || isExistProductDescription;
      return isExist;
    },
    async exportExcel() {
      if (!this.checkEmptyFilterForm()) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn ít nhất 1 điều kiện tìm kiếm',
        })
        return;
      }
      let arrayOrderBy = []
      if(!_.isEmpty(this.filterForm.orderCreatedBy)){

        this.filterForm.orderCreatedBy.map(s => {
          arrayOrderBy.push(s.userId)
        })
      }
      if (this.filterForm.isContacted && (!_.isArray(this.filterForm.contactedAt) || !this.filterForm.contactedAt.length)) {
        this.showContactedErrors = true
        return
      } else {
        this.showContactedErrors = false
      }
      const loader = this.$loading.show();
      let user = await TokenService.getUser()
      const userIdsParam = this.filterForm.userIds.filter(userItem => userItem.hasOwnProperty('userId')).map(itemMap => itemMap.userId)
      const cumulativePointMonthYear = {
          month: this.filterForm.monthPicker && moment(this.filterForm.monthPicker).format('MM') || null,
          year: this.filterForm.monthPicker && moment(this.filterForm.monthPicker).format('YYYY') || null,
          type: this.filterForm.compare,
          point: this.filterForm.inputPointCumulated || null,
      }
      const {orderCreatedBy, monthPicker, compare, inputPointCumulated, ...params} = this.filterForm
      ContactRepository.exportExcelContact({...params, orderCreatedBy: arrayOrderBy, cumulativePointMonthYear: cumulativePointMonthYear, username: user.username, userIds: userIdsParam,connectedSocial:this.filterForm.socialValue});
      loader.hide();
      this.$swal({
        title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
      });
      // if (_.get(response, 'success', false)) {
      //   if (response.data) {
      //     await downloadFile(_.get(response, 'data.csvFile', ''), _.get(response, 'data.fileName', ''));
      //     loader.hide();
      //   } else {
      //     this.$swal({
      //       type: 'error',
      //       title: 'Lỗi !',
      //       text: _.get(response, 'message', ''),
      //     })
      //   }
      // } else {
      //   loader.hide();
      //   this.$swal({
      //     type: 'error',
      //     title: 'Lỗi !',
      //     text: _.get(response, 'message', ''),
      //   })
      // }
    },
    getListUserOfContact() {
      let usersTemp = this.usersContactAdvise.map(s => ({ ...s }));
      if (this.isManager() || this.checkAuthorization('contact_view_all')) {
        usersTemp.unshift( {
          fullName: 'Không người phụ trách',
          id: -1
        });
      }
      // if (!this.isManager() && !this.checkAuthorization('contact_view_all')) {
      //   const dataUser = TokenService.getUser() || {};
      //   const userId = _.get(dataUser, 'id', '');
      //   if (this.isStaff()) {
      //     usersTemp =  usersTemp.filter(data => data.id == userId);
      //   } else {
      //     usersTemp =  usersTemp.filter(data => data.departmentId === dataUser.departmentId  || dataUser.listDepartmentIds.includes(data.departmentId));
      //   }
      // }
      this.usersTemp = usersTemp;
    },
    async getListMinistryTree() {
      this.appLoadingData(true)
      const respond = await OrganizationMachineRepository.listMinistryUserTree({
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      });
      this.appLoadingData(false)
      if (_.get(respond, 'success', false)) {
        this.ministries[0].children = _.get(respond, 'data', []);
        // this.open.push(this.ministries[0])
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', ''),
        })
      }
    },
    clickSelectUser() {
      this.openTree = !this.openTree
      if(_.isEmpty(this.ministries[0].children)) {
        this.getListMinistryTree();
      }
    },
    handleSearch: function (val) {
      if (val) {
        if (!this.allOpened) {
          this.lastOpen = this.open;
          this.allOpened = true;
          this.$refs.tree.updateAll(true);
        }
      } else {
        this.$refs.tree.updateAll(false);
        this.allOpened = false;
        this.open = this.lastOpen;
      }
    },
    removeNodeSelected() {
      this.filterForm.userIds = []
    },
    removeOrderSelected() {
      this.filterForm.orderCreatedBy = []
    },
    async getDistrictLists(tinhId) {
      if (!tinhId) {
        this.districtList = [];
        this.filterForm.huyenId = null;
        this.filterForm.schoolName = null;
        return;
      }
      const res = await AddressRepository.districts({limit: 1000}, tinhId)
      if (res.success) {
        this.districtList = _.get(res, 'data', [])
      } else {
        this.districtList = []
      }
    },
    async getSchoolLists() {
      if (!this.filterForm.huyenId) {
        this.schoolList = [];
        this.filterForm.schoolName = null;
        return;
      }
      const params = {
        tinhId: this.filterForm.tinhId,
        huyenId: this.filterForm.huyenId,
        limit: 1000
      }
      const res = await AddressRepository.schools(params)
      if (res.success) {
        this.schoolList = _.get(res, 'data', [])
      } else {
        this.schoolList = []
      }
    },
    async getListTags() {
      const params = {
        obj: "core_tags",
        attrs: ["id", "tagCode", "tagIcon", "tagName", "color"]
      }
      const response = await ContactRepository.getListTags(params);
      this.tags = _.get(response, 'data', []);
    },
      async getListSegmentCode() {
          try {
              const params = {
                  'sorts[createdAt]':  'desc'
              }
              const response = await TypeRepository.listSegmentCodeApi(params)
              if(response.success) {
                  this.listSegment = _.get(response, 'data', [])
              }else {
                  this.listSegment = []
              }
          }catch (e) {
              console.log(e)
          }
      },
    changenumberOfLearnTrial(event) {
      if ( event.target.valueAsNumber > 99 ) {
        this.filterForm.numberOfLearnTrial = 99
      }
      if ( event.target.valueAsNumber < 1 ) {
        this.filterForm.numberOfLearnTrial = 1
      }
      if(! Number.isInteger(event.target.valueAsNumber)) {
        this.filterForm.numberOfLearnTrial = Math.floor(event.target.valueAsNumber)
      }
    }
  },
  watch: {
    searchSchool(value) {
        if(value && this.schoolListComputed && this.schoolListComputed.length === 1 &&  !this.schoolListComputed[0].id) {
            this.filterForm.schoolName = value
        }
    },
    usersContactAdvise: {
      handler () {
        this.getListUserOfContact();
      },
    },
  },
  beforeDestroy() {
    Bus.$off('change-drawer-side-bar')
  },
};
</script>
<style scoped>

  /deep/.hide-date .daterangepicker.dropdown-menu{
    display: none
  }
  /deep/.show-date .daterangepicker.dropdown-menu{
    display: block;
  }
  .tree-user-selected {
    height: 34px;
    overflow-y: auto;
    border-bottom: 1px solid #d2d2d2;
  }
  .menu-wrapper-tree-user {
    background: #FFFFFF !important;
  }
  .tree-view-wrapper {
    max-height: 350px;
    overflow-y: auto;
  }
  .icon-clear-all {
    position: absolute;
    right: 15px;
    top: 20px;
    background: white;
  }
  /deep/.v-subheader.theme--light {
    width: 100%;
    background: rgb(206, 150, 104);
  }
</style>
<style lang='scss'>
.custom-font-input {
  .v-input__slot {
    height: 23px !important;
  }
 .v-select__selection.v-select__selection--comma {
  font-size: 18px !important;
 }
}
.custom-font-input-number {
  .v-text-field__slot {
    height: 23px !important;
  }
}
</style>
